import { NewletterService } from "./services/http";
import { Alert } from "./services/components";

function newsletter() {
  const form = document.getElementById("form-newsletter");
  const service = new NewletterService();
  form &&
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      const email = document.querySelector(
        "#form-newsletter input[name=email]",
      );

      if (!email.value) {
        Alert.warning("No Email is given");
        return;
      }

      service
        .send({ email: email.value })
        .done(() => {
          Alert.success("You're subscribed!");
        })
        .fail((res) => {
          Alert.error(
            "We couldn't send that right now. Please try again in a moment.",
          );
        });
    });
}
export default newsletter;
